// Toasts: a corner stack fed by `useToasts` (core/net/reducers), newest three only. Each has an
// icon, a dismiss button and a draining bar matching its lifetime. `placement="board"` floats the
// stack over the top of the encounter board so it never covers the HUD columns.
import { useToasts } from '../../core/net/reducers';
import { IconButton } from './Button';

const ICON = { info: 'i', error: '!', success: '✓' } as const;
const VISIBLE = 3;

export function Toasts({ placement = 'corner' }: { placement?: 'corner' | 'board' }) {
  const toasts = useToasts((s) => s.toasts).slice(-VISIBLE);
  const dismiss = useToasts((s) => s.dismiss);
  if (!toasts.length) return null;
  return (
    <div className={`fk-toasts ${placement === 'board' ? 'fk-toasts--board' : ''}`} role="status" aria-live="polite" data-testid="toasts">
      {toasts.map((t) => (
        <div key={t.id} className={`fk-toast fk-hit fk-toast--${t.tone}`} style={{ ['--fk-toast-ms' as string]: `${t.tone === 'error' ? 8000 : 4000}ms` }} data-tone={t.tone}>
          <span className="fk-toast__icon" aria-hidden="true">{ICON[t.tone] ?? 'i'}</span>
          <span className="fk-toast__text">{t.text}</span>
          <IconButton small variant="ghost" label="Dismiss" onClick={() => dismiss(t.id)}>✕</IconButton>
          <span className="fk-toast__bar" aria-hidden="true" />
        </div>
      ))}
    </div>
  );
}
